/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, August 18th 2023, 11:04:33 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { PaymentMethod } from "lib/schemas";
import { EmphasisText, EmptyStateActionWrapper, Image } from "ui-widgets";

interface EmptyPaymentCredentialsCTAProps {
  noDataMessage: React.ReactNode;
  ctaButtons: React.ReactNode;
  paymentProvider: PaymentMethod;
}

export const EmptyPaymentCredentialsCTA = ({
  noDataMessage,
  ctaButtons,
  paymentProvider,
}: EmptyPaymentCredentialsCTAProps) => {
  return (
    <>
      <EmptyStateActionWrapper
        title={
          <>
            No <EmphasisText>{paymentProvider.name}</EmphasisText> credentials
          </>
        }
        description={noDataMessage}
        illustrationGraphic={<Image className="image-style-A" src={paymentProvider.image_url} alt="Onestop Admin" />}
      >
        {ctaButtons}
      </EmptyStateActionWrapper>
    </>
  );
};
